<template>
  <b-modal
    :id="modalId"
    centered
    title="Add Project"
    @hide="$emit('close')"
    hide-header-close
    @show="resetModal"
    @hidden="onHidden"
    @ok.prevent="handleOk"
    size="lg"
  >
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row>
        <b-form-group label="Project Name" :state="getState('name')" invalid-feedback="Name is required.">
          <b-form-input v-model="form.name" placeholder="Name" :state="getState('name')" maxlength="255" />
        </b-form-group>
        <b-form-group label="Competency" :state="getState('competency')" invalid-feedback="Competency is required.">
          <v-select
            v-model="form.competency"
            :options="competencyOptions"
            multiple
            label="competency"
            :reduce="(e) => e.competency_id"
            placeholder="Select Competency"
          />
        </b-form-group>
        <b-row>
          <b-col class="col-6">
            <b-form-group label="Start Date" :state="getState('start_date')" invalid-feedback="Start Tanggal wajib diisi.">
              <v-date-picker
                class="w-75"
                v-model="form.start_date"
                type="date"
                format="DD-MM-YYYY"
                placeholder="Select Start Date"
                :disabled-date="disableDateBefore"
                @input="clearError('start_date')"
              />
            </b-form-group>
          </b-col>
          <b-col class="col-6">
            <b-form-group label="End Date" :state="getState('end_date')" invalid-feedback="End Tanggal wajib diisi.">
              <v-date-picker
                class="w-75"
                v-model="form.end_date"
                type="date"
                format="DD-MM-YYYY"
                placeholder="Select End Date"
                :disabled-date="disableDateBefore"
                @input="clearError('end_date')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group
          label="Project Description"
          :state="getState('description')"
          invalid-feedback="Description is required."
        >
          <b-form-textarea
            rows="2"
            v-model="form.description"
            placeholder="Project Description"
            :state="getState('description')"
          />
        </b-form-group>
        <b-form-group label="Business Need" :state="getState('business_need')" invalid-feedback="Business Need is required.">
          <b-form-textarea
            rows="2"
            v-model="form.business_need"
            placeholder="Business Need"
            :state="getState('business_need')"
          />
        </b-form-group>
        <b-form-group label="Objectives" :state="getState('objectives')" invalid-feedback="Objectives is required.">
          <b-form-textarea rows="2" v-model="form.objectives" placeholder="Objectives" :state="getState('objectives')" />
        </b-form-group>
        <b-form-group label="Goals" :state="getState('goals')" invalid-feedback="Goals is required.">
          <b-form-textarea rows="2" v-model="form.goals" placeholder="Goals" :state="getState('goals')" />
        </b-form-group>
        <b-form-group label="Project Scope" :state="getState('scope')" invalid-feedback="Scope is required.">
          <v-select v-model="form.scope" :options="scopeOptions" label="scope" placeholder="Select Scope" />
        </b-form-group>
        <b-form-group label="Constraints" :state="getState('constraints')" invalid-feedback="Constraints is required.">
          <b-form-textarea rows="2" v-model="form.constraints" placeholder="Constraints" :state="getState('constraints')" />
        </b-form-group>
        <b-form-group label="Deliverables" :state="getState('deliverables')" invalid-feedback="Deliverables is required.">
          <b-form-textarea
            rows="2"
            v-model="form.deliverables"
            placeholder="Deliverables"
            :state="getState('deliverables')"
          />
        </b-form-group>
        <b-row class="pr-0">
          <div class="d-flex justify-content-between pr-0">
            <label>Project Team</label>
            <b-button variant="primary" @click="addProjectTeams">
              <span class="fe fe-file-plus"></span>
              Add Project Teams
            </b-button>
          </div>
          <template v-for="(item, index) in form.teams">
            <b-col class="col-5">
              <b-form-group label="Role" :state="getState(`teams.${index}.role`)" invalid-feedback="Role is required.">
                <v-select v-model="item.role" :options="roleOptions" label="role" placeholder="Select Role" />
              </b-form-group>
            </b-col>
            <b-col class="col-5">
              <b-form-group
                label="Employee"
                :state="getState(`teams.${index}.nik`)"
                invalid-feedback="Employee is required."
              >
                <v-select
                  v-model="item.nik"
                  :options="employeeOptions"
                  :reduce="(e) => e.employee_nik"
                  label="employee_name"
                  :disabled="index === 0"
                  placeholder="Select Employee"
                />
              </b-form-group>
            </b-col>
            <b-col v-if="index !== 0" class="col-1 d-flex align-items-center justify-items-center">
              <b-button
                v-if="index !== 0"
                variant="primary"
                @click="delProjectTeams(index)"
                style="height: 28.8px; width: 28.8px; font-size: small; margin-top: 4px"
              >
                <span class="fe fe-trash"></span>
              </b-button>
            </b-col>
          </template>
        </b-row>
        <b-form-group label="Project Impact A" :state="getState('impact_a')" invalid-feedback="Impact A is required.">
          <v-select v-model="form.impact_a" :options="impactAOptions" label="impact_a" placeholder="Select Impact A" />
        </b-form-group>
        <b-form-group label="Impact" :state="getState('impact')" invalid-feedback="Impact is required.">
          <b-form-textarea rows="2" v-model="form.impact" placeholder="Impact" :state="getState('impact')" />
        </b-form-group>
        <b-form-group label="Project Impact B" :state="getState('impact_b')" invalid-feedback="Impact B is required.">
          <v-select v-model="form.impact_b" :options="impactBOptions" label="impact_b" placeholder="Select Impact B" />
        </b-form-group>

        <b-form-group label="Attachment" :state="getState('files')" invalid-feedback="Attachment is required.">
          <p class="text-muted small mb-2">
            Upload your attachment in image or PDF format (JPG, JPEG, PNG, PDF). Max file size: 2MB
          </p>

          <div
            class="dropzone p-4 border rounded text-center"
            :class="{ 'border-danger': isDragging, 'is-invalid': !selectedFile && submitted }"
            @dragover.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false"
            @drop.prevent="handleDrop"
          >
            <div v-if="!selectedFile && !previewUrl">
              <i class="fe fe-upload-cloud text-muted mb-2" style="font-size: 3rem"></i>
              <p class="text-muted mb-2">Drag & drop your attachment here or</p>
              <label class="btn btn-outline-danger btn-sm">
                Browse Files
                <input
                  type="file"
                  accept="image/jpeg,image/jpg,image/png,application/pdf"
                  @change="handleFileSelect"
                  hidden
                />
              </label>
            </div>

            <div v-else>
              <img
                v-if="previewUrl && !isPdf"
                :src="previewUrl"
                alt="Certificate Preview"
                class="img-fluid rounded mb-3"
                style="max-height: 250px"
              />
              <div v-else-if="isPdf" class="pdf-preview mb-3">
                <div class="pdf-icon-container">
                  <i class="fe fe-file-text"></i>
                </div>
                <p class="pdf-label mb-0">PDF File</p>
              </div>
              <div class="d-flex align-items-center justify-content-center gap-2">
                <span class="text-success">
                  <i class="fe fe-check-circle me-1"></i>
                  {{ selectedFile?.name || "N/A" }}
                </span>
                <button class="btn btn-outline-danger btn-sm" @click="removeFile">
                  <i class="fe fe-x"></i>
                </button>
              </div>
              <p class="text-muted small mt-2 mb-0">Size: {{ selectedFile ? formatFileSize(selectedFile?.size) : "N/A" }}</p>
            </div>
          </div>
        </b-form-group>
      </b-row>
    </b-form>

    <template #modal-footer>
      <b-button variant="primary" @click="handleOk" :disabled="isLoading" :key="isLoading">
        <b-spinner v-if="isLoading" small type="grow" class="me-2"></b-spinner>
        <span>{{ isLoading ? "Mengirim..." : "Submit" }}</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { formatTimeToHHMM, isPdfFile } from "../utils/utils";
import moment from "moment";

export default {
  name: "AddProjectModal",

  props: {
    modalId: { type: String, default: "add-project-modal" },
    competencyOptions: { type: Array, default: () => [] },
    employeeOptions: { type: Array, default: () => [] },
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      form: this.getInitialForm(),
      scopeOptions: ["Accross BU", "Across Dept./Div. ( Within BU)", "Within Dept./Div."],
      impactAOptions: ["Tangible", "Intangible"],
      impactBOptions: [
        "Percentage (actual/target) > 100%",
        "Percentage (actual/target) = 100%",
        "Percentage (actual/target) < 100%",
      ],
      roleOptions: ["Project Leader", "Project Member/Co. Leader", "Project Sponsor"],
      selectedFile: null,
      previewUrl: null,
      isPdf: false,
      isDragging: false,
      submitted: false,
      formErrors: {},
      suppressValidation: false,
    };
  },

  watch: {
    "form.competency_id": async function (val, oldVal) {
      if (val === oldVal) return;
      this.form.coaching_id = null;
      await this.getListCoaching(val);
    },
  },

  methods: {
    formatTimeToHHMM,
    isPdfFile,
    getState(field) {
      if (this.formErrors[field]) return false;
      return null;
    },

    clearError(field) {
      if (this.formErrors[field]) {
        this.$delete(this.formErrors, field);
      }
    },

    disableDateBefore(date) {
      const today = moment().startOf("day");
      const current = moment(date);
      return current.isBefore(today, "day");
    },

    onHidden() {
      this.resetModal();
      this.$emit("close");
    },

    addProjectTeams() {
      this.form.teams.push({
        role: "",
        nik: "",
      });
    },

    delProjectTeams(index) {
      this.form.teams.splice(index, 1);
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },

    validateAll() {
      this.formErrors = {};

      if (!this.form.name) this.formErrors.name = "Name is required.";
      else if (this.form.name.length > 255) this.formErrors.name = "Name must be less than 255 characters.";

      if (!this.form.description) this.formErrors.description = "Description is required.";
      else if (this.form.description.length > 255)
        this.formErrors.description = "Description must be less than 255 characters.";

      if (!this.form.competency.length) this.formErrors.competency = "Competency is required.";

      if (!this.form.start_date) this.formErrors.start_date = "Start Tanggal wajib diisi.";

      if (!this.form.end_date) this.formErrors.end_date = "End Tanggal wajib diisi.";

      if (!this.form.business_need) this.formErrors.business_need = "Business Need is required.";
      else if (this.form.business_need.length > 255)
        this.formErrors.business_need = "Business Need must be less than 255 characters.";

      if (!this.form.objectives) this.formErrors.objectives = "Objectives is required.";
      else if (this.form.objectives.length > 255)
        this.formErrors.objectives = "Objectives must be less than 255 characters.";

      if (!this.form.goals) this.formErrors.goals = "Goals is required.";
      else if (this.form.goals.length > 255) this.formErrors.goals = "Goals must be less than 255 characters.";

      if (!this.form.scope) this.formErrors.scope = "Scope is required.";
      else if (this.form.scope.length > 255) this.formErrors.scope = "Scope must be less than 255 characters.";

      if (!this.form.constraints) this.formErrors.constraints = "Constraints is required.";
      else if (this.form.constraints.length > 255)
        this.formErrors.constraints = "Constraints must be less than 255 characters.";

      if (!this.form.deliverables) this.formErrors.deliverables = "Deliverables is required.";
      else if (this.form.deliverables.length > 255)
        this.formErrors.deliverables = "Deliverables must be less than 255 characters.";

      if (!this.form.impact_a) this.formErrors.impact_a = "Impact A is required.";
      else if (this.form.impact_a.length > 255) this.formErrors.impact_a = "Impact A must be less than 255 characters.";

      if (!this.form.impact) this.formErrors.impact = "Impact is required.";
      else if (this.form.impact.length > 255) this.formErrors.impact = "Impact must be less than 255 characters.";

      if (!this.form.impact_b) this.formErrors.impact_b = "Impact B is required.";
      else if (this.form.impact_b.length > 255) this.formErrors.impact_b = "Impact B must be less than 255 characters.";

      if (Array.isArray(this.form.teams)) {
        this.form.teams.forEach((team, index) => {
          if (!team.role || String(team.role).trim() === "") this.formErrors[`teams.${index}.role`] = "Role is required.";
          if (!team.nik || String(team.nik).trim() === "") this.formErrors[`teams.${index}.nik`] = "Employee is required.";
        });
      }

      if (!this.form.files) this.formErrors.files = "Attachment is required.";

      return Object.keys(this.formErrors).length === 0;
    },

    formatDateOnly(dateStr) {
      if (!dateStr) return null;
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    handleSubmit() {
      const isValid = this.validateAll();
      if (!isValid) return;

      const payload = {
        name: this.form.name,
        description: this.form.description,
        start_date: this.formatDateOnly(this.form.start_date),
        end_date: this.formatDateOnly(this.form.end_date),
        business_need: this.form.business_need,
        objectives: this.form.objectives,
        goals: this.form.goals,
        scope: this.form.scope,
        constraints: this.form.constraints,
        deliverables: this.form.deliverables,
        impact_a: this.form.impact_a,
        impact: this.form.impact,
        impact_b: this.form.impact_b,
        competency: this.form.competency,
        teams: this.form.teams,
        files: this.form.files,
      };

      this.$emit("add-experiential-learning", payload);
    },

    handleChangeFile(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.form.files = file;
      this.form.id = this.data.id;
    },

    handleFileSelect(event) {
      const file = event.target.files[0];
      this.processFile(file);
    },

    handleDrop(event) {
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      this.processFile(file);
    },

    processFile(file) {
      if (!file) return;

      const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
      if (!allowedTypes.includes(file.type)) {
        this.$swal({
          title: "Tipe File Tidak Valid",
          text: "Unggah file gambar (JPG, JPEG, PNG) atau PDF",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      const maxSize = 2 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$swal({
          title: "File Terlalu Besar",
          text: "Ukuran file maksimal 2MB",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      this.selectedFile = file;
      this.isPdf = file.type === "application/pdf";

      this.form.files = file;

      if (!this.isPdf) {
        this.previewUrl = URL.createObjectURL(file);
      } else {
        this.previewUrl = null;
      }

      this.formErrors.files = null;
    },

    removeFile() {
      this.selectedFile = null;
      this.isPdf = false;
      this.form.files = null;

      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }
    },

    formatFileSize(bytes) {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    getInitialForm() {
      return {
        name: null,
        description: null,
        start_date: null,
        end_date: null,
        business_need: null,
        objectives: null,
        goals: null,
        scope: null,
        constraints: null,
        deliverables: null,
        impact_a: null,
        impact: null,
        impact_b: null,
        competency: [],
        teams: [
          {
            role: "",
            nik: localStorage.getItem("nik"),
          },
        ],
      };
    },

    async resetModal() {
      if (this.isLoading) return;

      this.suppressValidation = true;

      await this.$nextTick();

      this.form = this.getInitialForm();
      this.formErrors = {};
      this.selectedFile = null;
      this.previewUrl = null;

      this.$nextTick(() => {
        this.suppressValidation = false;
      });
    },
  },

  beforeDestroy() {
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl);
    }
  },
};
</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}

.dropzone {
  background-color: #f8f9fa;
  border: 2px dashed #dee2e6 !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dropzone:hover,
.dropzone.border-danger {
  border-color: #e63757 !important;
  background-color: #fff5f7;
}

.dropzone.is-invalid {
  border-color: #dc3545 !important;
}

.course-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fce4e4;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gap-2 {
  gap: 0.5rem;
}

.me-1 {
  margin-right: 0.25rem;
}

.me-2 {
  margin-right: 0.5rem;
}

.me-3 {
  margin-right: 1rem;
}

/* PDF Preview Styles */
.pdf-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.pdf-preview .pdf-icon-container {
  width: 80px;
  height: 100px;
  background: linear-gradient(135deg, #e63757 0%, #c82333 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(230, 55, 87, 0.3);
}

.pdf-preview .pdf-icon-container i {
  font-size: 2.5rem;
  color: #fff;
}

.pdf-preview .pdf-label {
  margin-top: 1rem;
  font-weight: 600;
  color: #1a202c;
}
:deep(.mx-input) {
  height: 28px;
  font-size: 0.9375rem;
}
</style>
